<template>
    <div class="dashboard">
        <div class="content-area">
            <base-header
                :menu-listing="menuListing"
                @sidemenu="$emit('responsiveSideBar')"
            ></base-header>
            <div class="right-panel">
                <router-view></router-view>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    components: {},

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {}, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            menuListing: [
                {
                    anchorLink: '/insights/alerts',
                    menuLabel: 'Alerts',
                    name: 'view-alerts',
                    permission: ['view-alerts'],
                },
                {
                    anchorLink: '/insights/activity-dashboard',
                    name: 'view-activity-dashboard',
                    permission: ['view-activity-dashboard'],
                    menuLabel: 'Activity Dashboard',
                },
                {
                    anchorLink: '/insights/customer-statistics',
                    name: 'view-customer-statistics',
                    permission: ['view-customer-statistics'],
                    menuLabel: 'Customer Statistics',
                },
            ],
        }
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {}, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {}, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {}, // End of Component > mounted
} // End of export default
</script>
